// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2ItJy","fileBtn":"File_fileBtn__3-dIt","closeBtn":"File_closeBtn__g_fQd","fileSelected":"File_fileSelected__3D7zq","disabled":"File_disabled__3doNz"};